import React from 'react';
import { OverviewSection } from '@common/components/overview';

export interface RatingScaleExampleProps {
  points: number;
  descriptionKey: string;
  t: (key: string, options?: { number?: number }) => string;
  onClick?: (points: number) => void;
}

const RatingScaleExample: React.FC<RatingScaleExampleProps> = ({
  points,
  descriptionKey,
  t,
  onClick,
}) => {

  const getColorScheme = (point: number) => {
    const baseColors = [
      'tw-bg-red-dark',
      'tw-bg-orange-dark',
      'tw-bg-yellow-accent',
      'tw-bg-green-dark',
      'tw-bg-blue-brand'
    ];

    return baseColors.slice(0, point);
  };

  const colors = getColorScheme(points);

  const handleClick = () => {
    if (onClick) {
      onClick(points);
    }
  };

  return (
    <OverviewSection
      className={`!tw-border !tw-border-solid !tw-mt-0 !tw-border-gray-200 !tw-rounded-lg 
        !tw-flex !tw-flex-col !tw-p-4 !tw-gap-4 !tw-transition-all !tw-duration-200 ${
        onClick ? '!tw-cursor-pointer hover:!tw-bg-gray-100 hover:!tw-shadow-md' : ''
      }`}
      onClick={handleClick}
    >
      <div className="tw-flex tw-flex-row tw-gap-1">
        {colors.map((color) => (
          <div
            key={color}
            className={`tw-w-4 tw-h-1 tw-rounded-full ${color}`}
          />
        ))}
      </div>
      <div className="tw-flex tw-flex-col tw-gap-1">
        <div className="tw-text-base tw-text-gray-textDark tw-font-semibold">
          {t('performance:number_point_rating_scale', {
            number: points,
          })}
        </div>
        <div className="tw-text-sm-plus tw-text-gray-text tw-font-normal tw-whitespace-pre-wrap">
          {t(descriptionKey)}
        </div>
      </div>
    </OverviewSection>
  );
};

export default RatingScaleExample;
